<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Techniques
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Technique</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
            :items-per-page="10"
            pagination
          >
          <!-- <template #show="{item}">
            <td>
              <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
            </td>
          </template> -->
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="edit( item.technique_id )">Edit</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Technique"
        :show.sync="addModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            label="Name"
            :value.sync="form.technique_name"
            placeholder="Technique Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Internal ID"
            :value.sync="form.internal_id"
            placeholder="Internal ID"
            autocomplete="given-name"
          />
          <div style="padding-bottom:15px;">
            <label>Type</label>
            <v-select v-model="form.type" placeholder="Select Type" :options="typeOptions"></v-select>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Tech Type</label>
            <v-select 
              v-model="form.technique_type"
              :disabled="configureDisabled()"
              :options="techTypes"
            />
          </div>
          <CInput
            :lazy="false"
            label="Min Qty"
            style="margin-top:15px;"
            :value.sync="form.min_quantity"
            placeholder="Min Quantity"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="New Min Qty"
            :value.sync="form.new_min_quantity"
            placeholder="New Min Quantity"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Cost"
            :value.sync="form.cost"
            placeholder="Cost"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Can Go Under New Min Quantity?</label>
            <div>
              <CButton size="sm" @click="form.can_go_under_new_min_quantity = 1" :color="form.can_go_under_new_min_quantity === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.can_go_under_new_min_quantity = 0" style="margin-left:5px;" :color="form.can_go_under_new_min_quantity === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <CInput v-if="form.can_go_under_new_min_quantity" label="Under New Min Quantity Upcharge" type="double" placeholder="Ex 75.00" v-model="form.under_min_quantity_upcharge"></CInput>
          <CInput
            :lazy="false"
            label="Lead Time (days)"
            :value.sync="form.lead_time"
            placeholder="Lead Time"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Description"
            :value.sync="form.description"
            placeholder="Description"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;">
            <label>Programs</label>
            <multiselect
              v-if="programs" 
              v-model="form.programs" 
              :options="programs" 
              :multiple="true" 
              label="program_name" 
              track-by="program_id"
            />
          </div>
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Program"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            :value.sync="editForm.style_name"
            placeholder="Program Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from 'vue-multiselect'
var methods = {}

methods.getData = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/techniques?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.getPrograms = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.programs = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.reset = function () {
  this.form = {name: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.edit = function (val) {
  this.$router.push({ path: '/techniques/' + val + '/edit' })
}

methods.save = function () {
  let self = this
  axios.post(this.$apiAdress + '/api/techniques/save?token=' + localStorage.getItem('api_token'), self.editForm)
  .then(function (response) {

  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/techniques/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.addModal = false
      self.form = self.getForm()
      // this.$router.push({ path: '/techniques/' + val + '/edit' })
      // self.items.push(response.data)
      // self.form = {style_name: ''}
      // self.addModal = false
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getForm = function () {
  return {
    technique_name: '',
    internal_id: '',
    type: '',
    technique_type: '',
    min_quantity: '',
    new_min_quantity: '',
    cost: '',
    lead_time: '',
    programs: '',
    can_go_under_new_min_quantity: '',
    under_min_quantity_upcharge: '',
    description: ''
  }
}

methods.configureDisabled = function () {
  if (this.form.type === 'embroideries' || this.form.type === 'heat_seals') {
    return true
  } else {
    return false
  }
}

export default {
  name: 'Techniques',
  data() {
    return {
      items: [],
      fields: ['technique_name', 'internal_id', 'type', 'technique_type', 'cost', 'lead_time', 'min_quantity', 'new_min_quantity', 'edit'],
      typeOptions: ['components', 'embroideries', 'heat_seals'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      programs: null,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false,
      techTypes: ['TAPE', 'H', 'PPE', 'PPMP', 'PPSM', 'PPHI', 'PPL']
    }
  },
  components: {
    Multiselect
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  watch: {
    'form.type': function (newVal, oldVal) {
      if (this.form.type === 'embroideries') {
        this.form.technique_type = 'TAPE'
      } else if (this.form.type === 'heat_seals') {
        this.form.technique_type = 'H'
      }
    }
  },
  mounted: function(){
    this.getData()
    this.getPrograms()
  }
}
</script>
